import { defineEnum } from '@siclop/kstone-vue'

export enum ContractType {
  CDI = 0,
  CDD = 1,
  Freelance = 2,
  Intern = 3,
  Apprentice = 4,
  PartTime = 5,
  Temporary = 6
}

export const useContractTypeLabels = defineEnum({
  i18nPrefix: 'ksproject.enums.contractType',
  entries: {
    [ContractType.CDI]: { key: 'cdi', label: 'CDI' },
    [ContractType.CDD]: { key: 'cdd', label: 'CDD' },
    [ContractType.Freelance]: { key: 'freelance', label: 'Freelance' },
    [ContractType.Intern]: { key: 'intern', label: 'Stagiaire' },
    [ContractType.Apprentice]: { key: 'apprentice', label: 'Apprenti' },
    [ContractType.PartTime]: { key: 'partTime', label: 'Temps partiel' },
    [ContractType.Temporary]: { key: 'temporary', label: 'Intérimaire' }
  }
})

/** @deprecated Utiliser useContractTypeLabels().getLabel() */
export const ContractTypeLabels: Record<ContractType, string> = {
  [ContractType.CDI]: 'CDI',
  [ContractType.CDD]: 'CDD',
  [ContractType.Freelance]: 'Freelance',
  [ContractType.Intern]: 'Stagiaire',
  [ContractType.Apprentice]: 'Apprenti',
  [ContractType.PartTime]: 'Temps partiel',
  [ContractType.Temporary]: 'Intérimaire'
}
